import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateDeleteItem = {
  deleteItem: { data: null, loading: false, error: null },
};

export const deleteItem = createAsyncThunk('user/deleteItem', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .post(`/delete/item`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerDeleteItem = {
  [deleteItem.pending]: (state) => {
    state.deleteItem.loading = true;
  },
  [deleteItem.fulfilled]: (state, action) => {
    state.deleteItem.loading = false;
    state.deleteItem.data = action.payload;
    state.deleteItem.error = null;
  },
  [deleteItem.rejected]: (state, action) => {
    state.deleteItem.data = null;
    state.deleteItem.loading = false;
    state.deleteItem.error = action.payload;
  },
};
